import { Grid, useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";
import Box from "ReusableComponents/Box";
import Text from "ReusableComponents/Text";
import LogoFooter from "assets/logoFooter.svg";
import Youtube from "assets/youtube.svg";
import Instagram from "assets/instagram.svg";
import Twitter from "assets/twitter-x-logo.svg";
import Facebook from "assets/facebook.svg";
import FooterLinks from "../FooterLinks/FooterLinks";
import Separators from "ReusableComponents/Separators";
import FooterBox from "./FooterBox";
import { COLORS, WEIGHT } from "theme";
import { apiClient } from "api/apiClient";
import { sortData } from "utils";
import "../Header/LinkAnimation.css";
import { useTranslation } from "react-i18next";
import { useLanguage } from "LanguageContext";

const Footer = () => {
  const { t } = useTranslation();
  const { selectedLanguage } = useLanguage();

  const smallScreen = useMediaQuery("(max-width: 400px)");
  const [footerdata, setfooterdata] = useState([]);

  useEffect(() => {
    apiClient.getFooterColumns(selectedLanguage).then((res) => {
      console.log(res.data);
      setfooterdata(sortData(res?.data, "column_number"));
    });
  }, []);

  return (
    <Grid
      container
      spacing={2}
      style={{
        width: "auto",
        background: "black",
        padding: smallScreen ? "24px" : "80px",
      }}
    >
      <Grid item xs={12} lg={4} md={4}>
        <Box display="flex" flexDirection="column">
          <Box>
            <img src={LogoFooter} alt="logo" />
          </Box>
          <Box margin="24px 0">
            <Text textColor="white" fontWeight="500">
              {t("Follow Us")}
            </Text>
            <Box display="flex" w="150px" justifyContent="space-between">
              <a
                href="https://www.facebook.com/EulerMotors"
                rel="noreferrer"
                target={"_blank"}
              >
                <img
                  style={{ cursor: "pointer" }}
                  src={Facebook}
                  alt="Facebook"
                />
              </a>
              <a
                href="https://instagram.com/eulermotors"
                target={"_blank"}
                rel="noreferrer"
              >
                <img
                  style={{ cursor: "pointer" }}
                  src={Instagram}
                  alt="Instagram"
                />
              </a>
              <a
                href="https://twitter.com/Euler_Motors"
                target={"_blank"}
                rel="noreferrer"
              >
                <img
                  style={{ cursor: "pointer", background: '#99CEFB', height: '30px', width: '30px', borderRadius: '50%', padding: '5px' }}
                  src={Twitter}
                  alt="Twitter"
                />
              </a>
              <a
                href="https://www.youtube.com/c/EulerMotors"
                target={"_blank"}
                rel="noreferrer"
              >
                <img
                  style={{ cursor: "pointer" }}
                  src={Youtube}
                  alt="Youtube"
                />
              </a>
            </Box>
          </Box>
        </Box>
      </Grid>
      <Grid item md={8} sm={6} xs={12}>
        <Grid container spacing={2}>
          <Grid item sm={12} md={4}>
            <FooterLinks data={footerdata[0]?.attributes?.footerlinks?.data} />
          </Grid>

          <Grid item md={4} sm={12} xs={12}>
            <FooterLinks data={footerdata[1]?.attributes?.footerlinks?.data} />
          </Grid>
          <Grid item md={4} sm={12} xs={12}>
            <FooterLinks data={footerdata[2]?.attributes?.footerlinks?.data} />
          </Grid>
        </Grid>
      </Grid>
      <Grid
        item
        xs={12}
        sx={{ padding: 0, marginTop: "50px", textAlign: "center" }}
      >
        <Separators h="2px" w="100%" background={"gray"} />
      </Grid>

      <Grid item xs={12} md={4} sx={{ padding: 0, textAlign: "center" }}>
        <FooterBox
          main={"Call Us"}
          sec={"1800 1238 1238"}
          isNumber={true}
          ternary={"Mon-Sat (9.30AM-6.30PM)"}
        />
      </Grid>
      <Grid item xs={12} md={4} sx={{ padding: 0, textAlign: "center" }}>
        <FooterBox
          main={"Write to us at:"}
          sec={"customercare@eulermotors.com"}
        />
      </Grid>
      <Grid item xs={12} md={4} sx={{ padding: 0, textAlign: "center" }}>
        <FooterBox
          main={"Address:"}
          sec={
            "A-39, near Pocket C, Block B, Mohan Cooperative Industrial Estate, Badarpur,"
          }
          ternary={"New Delhi - 110044"}
          noHref
        />
      </Grid>

      <Grid
        item
        xs={12}
        style={{
          background: COLORS.black,
          marginTop: "35px",
          textAlign: "center",
          padding: "20px",
        }}
      >
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          w="100%"
        >
          <Text
            fontSize={"11px"}
            textColor={COLORS.lightGrey}
            fontWeight={WEIGHT.regular}
            margin={0}
          >
            {t("Copyright")} © {new Date().getFullYear()} {t("Euler Moters")}
          </Text>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Footer;
